{
  "success": {
    "default": "Operación conseguida",
    "save": "Copia de seguridad realizada",
    "remove": "Eliminación realizada",
    "detach": {
      "user": "El usuario siguiente ha sido apartado de la red { sectorName } | Los siguientes usuarios han sido apartados de la red { sectorName }",
      "device": "El siguiente equipo ha sido apartado de la red { sectorName } | Los siguientes equipos han sido apartados de la red { sectorName }",
      "application": "La siguiente aplicación ha sido apartada de la red { sectorName } | Las siguientes aplicaciones han sido apartadas de la red { sectorName }",
      "userGroup": "El siguiente grupo de usuarios ha sido apartado de la red { sectorName } | Los siguientes grupos de usuarios han sido apartados de la red { sectorName }",
      "dtwins": "El siguiente equipo ha sido apartado de la red { sectorName } | Los siguientes equipos han sido apartados de la red { sectorName }"
    },
    "attach": {
      "user": "El siguiente usuario ha sido añadido a la red { sectorName } | Los siguientes usuarios han sido añadidos a la red { sectorName }",
      "device": "El siguiente equipo ha sido añadido a la red { sectorName } | Los siguientes equipos han sido añadidos a la red { sectorName }",
      "application": "la siguiente aplicación ha sido añadida a la red { sectorName } | Las siguientes aplicaciones han sido añadidas a la red { sectorName }",
      "userGroup": "El siguiente grupo de usuarios ha sido añadido a la red { sectorName } | Los siguientes grupos de usuarios han sido añadidos a la red { sectorName }",
      "dtwins": "El siguiente equipo ha sido añadido a la red { sectorName } | Los siguientes equipos han sido añadidos a la red { sectorName }"
    },
    "certificate": {
      "generation": "La generación del certificado de usuario ha finalizado correctamente."
    }
  },
  "cancellation": {
    "cancel": "Cambios anulados"
  },
  "inProgress": {
    "save": "Copia de seguridad en curso"
  },
  "error": {
    "default": "Se ha producido un error",
    "unexpectedApiError": "Ha surgido un error imprevisto",
    "save": "Fallo de la copia de seguridad",
    "remove": "La eliminación no se ha podido realizar",
    "upload": "Se ha producido un error al importar. Vuelva a comenzar",
    "detach": {
      "user": "Fallo de separación de la red { sectorName } del siguiente usuario | Fallo de separación de la red { sectorName } de los siguientes usuarios",
      "device": "Fallo de separación de la red { sectorName } del siguiente equipo | Fallo de separación de la red { sectorName } de los siguientes equipos",
      "application": "Fallo de separación de la red { sectorName } de la siguiente aplicación | Fallo de separación de la red { sectorName } de las siguientes aplicaciones",
      "userGroup": "Fallo de separación de la red { sectorName } del siguiente grupo de usuarios | Fallo de separación de la red { sectorName } de los siguientes grupos de usuarios",
      "dtwins": "Fallo de separación de la red { sectorName } del siguiente equipo | Fallo de separación de la red { sectorName } de los siguientes equipos"
    },
    "attach": {
      "user": "Fallo de incorporación a la red { sectorName } del siguiente usuario | Fallo de incorporación a la red { sectorName } de los siguientes usuarios",
      "device": "Fallo de incorporación a la red { sectorName } del siguiente equipo | Fallo de incorporación a la red { sectorName } de los siguientes equipos",
      "application": "Fallo de incorporación a la red { sectorName } de la siguiente aplicación | Fallo de incorporación a la red { sectorName } de las siguientes aplicaciones",
      "userGroup": "Fallo de incorporación a la red { sectorName } del siguiente grupo de usuarios | Fallo de incorporación a la red { sectorName } de los siguientes grupos de usuarios",
      "dtwins": "Fallo de incorporación a la red { sectorName } del siguiente equipo | Fallo de incorporación a la red { sectorName } de los siguientes equipos"
    },
    "campaign": {
      "firmware": "La actualización del firmware no se ha podido programar con la fecha deseada"
    },
    "startDate": "La campaña ya ha comenzado, no puede cambiar las fechas de inicio ni de fin.",
    "keystore": {
      "aliasAlreadyUsed": {
        "title": "El alias ya se está utilizando.",
        "message": "Utilice otro alias de certificado y vuelva a intentarlo."
      }
    },
    "certificate": {
      "parsing": "Error de certificado",
      "notValid": "El certificado del API no es válido"
    }
  }
}
